import React from 'react';
import { getText } from '../../utils/functions';
import Separator from '../basicComponents/Separator';
import { MainAppContext } from '../../MainAppContext';


function MobileTranslateMenuPopUp({
	translate,
	onClick,
	colors,
	languages,
	/* OPTIONAL PROPS */
	classNameDIV = 'flex flex-col items-center w-full',
	styleDIV,
}) {
	/* Default values for the styles */
	const defaultStyleDIV = {
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };

	/* Check if last item on array */
	const isLast = item => languages?.indexOf(item) === languages.length - 1;

	/* On click change language and close */
	const onClickOption = value => {
		translate.changeLanguage(value);
		onClick();
	};

	return <div
		id='MENU IDIOMAS'
		className={classNameDIV}
		style={overrideStyleDIV}
	>
		{languages.map(language => (
			<Option
				key={language.value}
				checked={language.value === translate.currentLanguage}
				onClick={() => onClickOption(language.value)}
				isLast={isLast(language)}
				colors={colors}
				translate={translate}
				option={language}
			/>
		))}
	</div>;
}

function Option({
	option,
	colors,
	translate,
	checked,
	onClick,
	/* OPTIONAL PROPS */
	isLast,
	classNameSEPARATOR = 'w-full flex justify-between',
	classNameITEM,
	styleITEM,
	styleOuterCIRCLE,
	styleInnerCIRCLE,
}) {
	/* Default values for the styles */
	const defaultClassNameITEM = {
		div: 'w-full flex justify-between p-4 font-lato',
		buttonDiv: 'relative w-5 h-5 rounded-full',
		button: 'absolute top-0.75 left-0.75 w-3 h-3 rounded-full focus:outline-none',
		buttonSelected: '',
		buttonActive: '',
		span: '',
	};
	const defaultStyleOuterCIRCLE = {
		border: `1px solid ${colors?.primary}`,
	};
	const defaultStyleInnerCIRCLE = {
		backgroundColor: checked && colors?.primary,
	};
	const defaultStyleHorizontal = {
		borderBottom: `1px solid ${colors?.primary}`,
	};
	const defaultStyleITEM = {
		color: colors?.text,
	};
	const {
		formData,
		formDataIni,
		setFormData,
		setFormDataIni
	} = React.useContext(MainAppContext);

	const changeLanguage = item => {
		setFormData({
			...formData,
			language: item.value
		});
		setFormDataIni({
			...formDataIni,
			language: item.value
		});
	};
	/* This way you can modify or add fields without affecting the others */
	const overrideClassNameITEM = { ...defaultClassNameITEM, ...classNameITEM };
	const overrideStyleOuterCIRCLE = { ...defaultStyleOuterCIRCLE, ...styleOuterCIRCLE };
	const overrideStyleInnerCIRCLE = { ...defaultStyleInnerCIRCLE, ...styleInnerCIRCLE };
	const overrideStyleInnerITEM = { ...defaultStyleITEM, ...styleITEM };


	return <React.Fragment>
		<div
			className={overrideClassNameITEM.div}
			onClick={() => {
				changeLanguage(option);
				onClick();
			}
			}
			style={overrideStyleInnerITEM}
		>
			{/* TEXT */}
			<span
				className={overrideClassNameITEM.span}
			>{getText(option, translate)}</span>
			<div>
				{/* CIRCLES */}
				<div>
					{/* outer circle */}
					<div className={overrideClassNameITEM.buttonDiv} style={overrideStyleOuterCIRCLE}>
						{/* inner circle */}
						<button
							type="button"
							className={`${overrideClassNameITEM.button} ${checked && overrideClassNameITEM.buttonSelected}`}
							style={overrideStyleInnerCIRCLE}
						/>
					</div>
				</div>
			</div>
		</div>
		{!isLast
			&& <Separator
				className={classNameSEPARATOR}
				style={defaultStyleHorizontal} />
		}
	</React.Fragment>;
}

export default MobileTranslateMenuPopUp;
